import React from "react";
import {
  FormField as FormFieldInterface,
  FormFieldType,
} from "@slootsantos/certain-forms/dist/types";

import { formFieldMap } from "./formfieldMap";

type FormFieldProps = FormFieldInterface &
  React.InputHTMLAttributes<{ value: string }> &
  React.SelectHTMLAttributes<{ value: string }> & { captureChanges?: boolean };

const FormField: React.FunctionComponent<FormFieldProps> = (props) => {
  const { captureChanges, ...fieldProps } = props;
  const Input = formFieldMap[props.type];
  // Only the opted-in form supplies a controlled textarea through defaultValue.
  const textareaValue =
    captureChanges && props.type === FormFieldType.area
      ? { defaultValue: undefined, value: props.defaultValue ?? "" }
      : {};

  // @ts-ignore
  return <Input id={props.name} {...fieldProps} {...textareaValue} />;
};

export default FormField;
